function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React, { useState } from 'react';
import { useEventTracker } from '@applyboard/ui-utils';
import { GRAY, Box, Button, FormLabel, Grid, Typography, Radio, RadioGroup, Modal, FormControlLabel, useId } from '@applyboard/ui-components';
import useInitialProps from "../../hooks/useInitialProps";
export function DiscrepancyModal(_ref) {
  var discrepancyIncomingLabel = _ref.discrepancyIncomingLabel,
    discrepancyMessage = _ref.discrepancyMessage,
    discrepancyOptions = _ref.discrepancyOptions,
    onClose = _ref.onClose,
    onSubmit = _ref.onSubmit,
    submitting = _ref.submitting,
    open = _ref.open,
    title = _ref.title;
  var _useInitialProps = useInitialProps(),
    applicationId = _useInitialProps.id,
    temp_additional = _useInitialProps.temp_additional;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var initalProfileValues = Object.assign.apply(Object, [{}].concat(_toConsumableArray(discrepancyOptions.map(function (discrepancy) {
    return _defineProperty({}, discrepancy.field, discrepancy.options[0].value);
  }))));
  var _useState = useState(initalProfileValues),
    _useState2 = _slicedToArray(_useState, 2),
    selectedValues = _useState2[0],
    setSelectedValues = _useState2[1];
  return /*#__PURE__*/React.createElement(Modal, {
    title: title,
    open: open,
    maxWidth: "sm",
    handleClose: function handleClose() {
      trackEvent({
        event: "Single Application -".concat(discrepancyIncomingLabel, " - Clicked Cancel With Data"),
        data: {
          applicationId: applicationId,
          applicantRpId: temp_additional === null || temp_additional === void 0 ? void 0 : temp_additional.agent_id,
          initialFields: Object.keys(initalProfileValues)
        }
      });
      onClose();
    },
    footerButtons: function footerButtons() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          trackEvent({
            event: "Single Application -".concat(discrepancyIncomingLabel, " - Clicked Cancel With Data"),
            data: {
              applicationId: applicationId,
              applicantRpId: temp_additional === null || temp_additional === void 0 ? void 0 : temp_additional.agent_id,
              initialFields: Object.keys(initalProfileValues)
            }
          });
          onClose();
        },
        color: "secondary",
        variant: "text",
        disabled: submitting
      }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          var fieldsToOverwrite = [];
          Object.keys(selectedValues).forEach(function (field) {
            if (initalProfileValues[field] !== selectedValues[field]) {
              fieldsToOverwrite.push(field);
            }
          });
          onSubmit(fieldsToOverwrite);
          trackEvent({
            event: "Single Application -".concat(discrepancyIncomingLabel, " - Clicked Overwrite With Data"),
            data: {
              applicationId: applicationId,
              applicantRpId: temp_additional === null || temp_additional === void 0 ? void 0 : temp_additional.agent_id,
              initialFields: Object.keys(initalProfileValues),
              overwrittenFields: fieldsToOverwrite
            }
          });
        },
        loading: submitting
      }, "Submit"));
    }
  }, /*#__PURE__*/React.createElement(Box, {
    mb: 5
  }, /*#__PURE__*/React.createElement(Typography, null, discrepancyMessage)), /*#__PURE__*/React.createElement(Box, {
    style: {
      borderBottomColor: "".concat(GRAY[18])
    },
    borderBottom: 1,
    pb: 2,
    pt: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "secondary"
  }, "Student Profile")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "secondary"
  }, discrepancyIncomingLabel)))), discrepancyOptions.map(function (discrepancy) {
    return /*#__PURE__*/React.createElement(DiscrepancyRow, {
      key: discrepancy.field,
      label: discrepancy.label,
      options: discrepancy.options,
      onChange: function onChange(value) {
        return setSelectedValues(_objectSpread(_objectSpread({}, selectedValues), {}, _defineProperty({}, discrepancy.field, value)));
      },
      value: selectedValues[discrepancy.field]
    });
  }));
}
function DiscrepancyRow(_ref3) {
  var label = _ref3.label,
    _onChange = _ref3.onChange,
    options = _ref3.options,
    value = _ref3.value;
  var labelId = useId();
  return /*#__PURE__*/React.createElement(Box, {
    borderBottom: 1,
    borderColor: GRAY[18],
    pb: 2,
    pt: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    xs: 4,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(FormLabel, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "secondary",
    id: labelId
  }, label))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    "aria-labelledby": labelId,
    row: true,
    value: value
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      style: {
        flex: 1,
        wordBreak: 'break-word'
      },
      control: /*#__PURE__*/React.createElement(Radio, null),
      key: option.value,
      label: option.label,
      value: option.value,
      onChange: function onChange(_, checked) {
        if (checked) {
          _onChange(option.value);
        }
      },
      mb: 0,
      ml: 1
    });
  })))));
}